<template>
  <div>
    <mainmenu selected="mystocks"></mainmenu>
      <div class="container">
          <h1>{{ $t("imports.page_title") }}</h1>
          <div class='card'>
            <div class="card-body" >
                <strong>{{$t('imports.import_from_csv')}}</strong>
                  <el-upload
                    ref="upload"
                    class="upload-demo"
                    drag
                    :headers="$http.headers.common"
                    :action="$http.options.root + 'import/upload_import'"
                    :on-success="uploadSuccess"
                    :limit="1"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">{{$t('imports.drop_csv_file_1')}} <em>{{$t('imports.drop_csv_file_2')}}</em></div>
                    <div class="el-upload__tip" slot="tip">{{$t('imports.file_limit')}}</div>
                  </el-upload>
            </div>
          </div>
    </div>
  </div>
</template>

<script>
import MainMenu from "./../widgets/MainMenu";
import settings from "./../backend/LocalSettings";

export default {
  name: "imports",
  components: {
    "mainmenu": MainMenu
  },
  data() {
    return {
      tableLoadingVisible: false,
      Results: [],
      Filters: {},
      PaginationInfo: {
        Page: 1,
        PerPage: 10,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100]
      }
    };
  },
  methods: {
    uploadSuccess: function(response, file, fileList)
    {
      this.upload_errors = response.Errors;
      
      this.$refs.upload.clearFiles();
    }
  }
};
</script>
  
<style>
</style>
